// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 三江直饮水订单列表
 * @param {Object} params 查询参数
 */
export function sanjiangOrderListApi(params) {
  return request({
    url: "admin/order/water/list",
    method: 'get',
    params: params
  });
}

//查看订单详情
export function sanjiangOrderDetailApi(orderId) {
  return request({
    url: "admin/order/water/detail/".concat(orderId),
    method: 'get'
  });
}

//订单导出order/water/export
export function sanjiangOrderExportApi(params) {
  return request({
    url: "admin/order/water/export",
    method: 'post',
    params: params
  });
}

//查看福豆
export function sanjiangOrderIntegralLogApi(orderId) {
  return request({
    url: "admin/order/station/getIntegralLog/".concat(orderId),
    method: 'get'
  });
}